module.exports = __webpack_public_path__ + "static/media/instructivoac1.b68251e9.png";